export const CLAIM_STATES = {
  0: "INIT",
  1: "CAPTCHA", 
  2: "RULES",
  3: "END",
  4: "NO_QR",
  5: "SUCCESS_NP_FORM",
  6: "COMING_SOON",
  7: "END_NP"
}